import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from 'axios';
import { useAuth } from "@/hooks/useAuth";
import { FaUser, FaEye, FaEyeSlash, FaLock, FaIdCard, FaTimes } from "react-icons/fa";
import fundoLogin from '@/assets/prime-login.png';
import { Link } from 'react-router-dom';
import Navbar from "../../Pages/Navbar/Navbar";


const Login = () => {
  const { fetchUser } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [cpf, setCpf] = useState("");
  const [otp, setOtp] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");
  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [modalEtapa, setModalEtapa] = useState(null);
  const [isSendingCode, setIsSendingCode] = useState(false);
  const [otpTimer, setOtpTimer] = useState(60);
  const [isOtpTimerActive, setIsOtpTimerActive] = useState(false);
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (isOtpTimerActive && otpTimer > 0) {
      const timer = setTimeout(() => setOtpTimer(otpTimer - 1), 1000);
      return () => clearTimeout(timer);
    } else if (otpTimer === 0) {
      setIsOtpTimerActive(false);
    }
  }, [otpTimer, isOtpTimerActive]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErro("");
    setIsLoggingIn(true);

    try {
const response = await axios.post("api/public/api/login", { email, password }, { withCredentials: true });
await fetchUser();

navigate(response.data.redirect_to || "/cliente", { replace: true });
    } catch (error) {
      setErro(error.response?.data?.message || "Credenciais inválidas.");
    } finally {
      setIsLoggingIn(false);
    }
  };

  const abrirModal = (etapa) => {
    setModalEtapa(etapa);
    setErro("");
    setSucesso("");
  };

  const fecharModal = () => {
    setModalEtapa(null);
    setCpf("");
    setOtp("");
    setNovaSenha("");
    setConfirmarSenha("");
    setErro("");
    setSucesso("");
    setOtpTimer(60);
    setIsOtpTimerActive(false);
  };

  const handleEnviarCPF = async () => {
    setErro("");
    setIsSendingCode(true);
    try {
      const response = await axios.post("/api/public/api/enviar-otp", { cpf });
      setSucesso(response.data.message);
      abrirModal("inserir-otp");
      setIsOtpTimerActive(true);
    } catch (error) {
      setErro(error.response?.data?.message || "CPF não encontrado.");
    } finally {
      setIsSendingCode(false);
    }
  };

  const handleReenviarOTP = async () => {
    setErro("");
    setIsSendingCode(true);
    setOtpTimer(0);
    setIsOtpTimerActive(false);

    try {
      const response = await axios.post("/api/public/api/renviar-otp", { cpf });
      setSucesso(response.data.message);
      setOtpTimer(60);
      setIsOtpTimerActive(true);
    } catch (error) {
      setErro(error.response?.data?.message || "Erro ao reenviar o código.");
    } finally {
      setIsSendingCode(false);
    }
  };

  const handleVerificarOTP = async () => {
    setErro("");
    try {
      const response = await axios.post("/api/public/api/verificar-otp", { cpf, otp });
      setSucesso(response.data.message);
      abrirModal("nova-senha");
    } catch (error) {
      setErro(error.response?.data?.message || "Código inválido.");
    }
  };

  const handleRedefinirSenha = async () => {
    setErro("");
    if (novaSenha !== confirmarSenha) {
      setErro("As senhas não coincidem.");
      return;
    }

    try {
      const response = await axios.post("/api/public/api/redefinir-senha", { cpf, novaSenha });

      if (response.status === 200) {
        setSucesso("Senha alterada com sucesso!");
      }
    } catch (error) {
      setErro(error.response?.data?.message || "Erro ao redefinir senha.");
    }
  };

  return (
    <>
     <Navbar />
<div
  className="min-h-screen flex justify-center items-start bg-no-repeat bg-center bg-cover relative overflow-hidden"
  style={{
    backgroundImage: `url(${fundoLogin})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  }}
>
       <div className="absolute inset-0 bg-black/60 backdrop-blur-md" />

        <div className="relative z-10 bg-black/80 p-4 sm:p-6 rounded-lg shadow-xl shadow-black/50 max-w-sm w-full mt-10 sm:mt-20">
        <h2 className="text-2xl font-bold mb-4 text-white text-center">Acesse sua Conta</h2>
        {erro && <p className="text-red-500 text-sm mb-3 text-center">{erro}</p>}
        {sucesso && <p className="text-green-500 text-sm mb-3 text-center">{sucesso}</p>}

        <form onSubmit={handleLogin} className="space-y-4">
          <div className="relative">
            <FaUser className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type="email"
              placeholder="E-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full pl-10 pr-3 py-2 bg-gray-800 border border-gray-600 rounded-md text-white placeholder-gray-500 focus:outline-none focus:border-yellow-400"
              required
            />
          </div>

          <div className="relative">
            <FaLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full pl-10 pr-10 py-2 bg-gray-800 border border-gray-600 rounded-md text-white placeholder-gray-500 focus:outline-none focus:border-yellow-400"
              required
            />
            <span
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 cursor-pointer hover:text-white"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>

          <button
            type="submit"
            className="w-full py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 transition-all duration-300 hover:scale-105"
            disabled={isLoggingIn}
          >
            {isLoggingIn ? "Entrando..." : "Entrar"}
          </button>
        </form>
<div className="flex justify-center gap-4 items-center mt-4 text-sm">
  <button
    onClick={() => abrirModal("cpf")}
    className="text-yellow-400 hover:text-white underline"
  >
    Esqueci minha senha
  </button>

  <Link
    to="/cadastro"
    className="text-yellow-400 hover:text-white underline"
  >
    Cadastre-se
  </Link>
</div> 
</div>

      {/* Modal CPF */}
      {modalEtapa === "cpf" && (
        <div className="fixed inset-0 bg-black/70 flex justify-center items-center z-50">
          <div className="relative bg-gray-800 p-6 rounded-lg max-w-sm w-full">
            <FaTimes
              className="absolute top-4 right-4 text-gray-400 hover:text-white cursor-pointer"
              onClick={fecharModal}
            />
            <h3 className="text-xl font-bold mb-2 text-white">Recuperar Senha</h3>
            <p className="text-gray-400 mb-4">Digite seu CPF:</p>
            <div className="relative mb-4">
              <input
                type="text"
                placeholder="Digite seu CPF"
                value={cpf}
                onChange={(e) => setCpf(e.target.value)}
                className="w-full pl-3 py-2 bg-gray-700 border border-gray-600 rounded-md text-white"
              />
              <FaIdCard className="absolute right-3 top-3 text-gray-400" />
            </div>
            <button
              onClick={handleEnviarCPF}
              className="w-full py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 transition-all"
              disabled={isSendingCode}
            >
              {isSendingCode ? "Enviando..." : "Enviar Código"}
            </button>
          </div>
        </div>
      )}

      {/* Modal OTP */}
      {modalEtapa === "inserir-otp" && (
        <div className="fixed inset-0 bg-black/70 flex justify-center items-center z-50">
          <div className="relative bg-gray-800 p-6 rounded-lg max-w-sm w-full">
            <FaTimes
              className="absolute top-4 right-4 text-gray-400 hover:text-white cursor-pointer"
              onClick={fecharModal}
            />
            <h3 className="text-xl font-bold mb-2 text-white">Verificação</h3>
            <input
              type="text"
              placeholder="Código OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              className="w-full pl-3 py-2 mb-4 bg-gray-700 border border-gray-600 rounded-md text-white"
            />
            <button
              onClick={handleVerificarOTP}
              className="w-full py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 transition-all"
            >
              Confirmar Código
            </button>
            {isOtpTimerActive ? (
              <p className="text-gray-400 text-sm mt-2">Aguarde {otpTimer}s para reenviar</p>
            ) : (
              <button
                onClick={handleReenviarOTP}
                className="w-full mt-2 py-2 bg-gray-700 text-white rounded-md hover:bg-gray-600"
                disabled={isSendingCode}
              >
                {isSendingCode ? "Enviando..." : "Reenviar Código"}
              </button>
            )}
          </div>
        </div>
      )}

      {/* Modal Nova Senha */}
      {modalEtapa === "nova-senha" && (
        <div className="fixed inset-0 bg-black/70 flex justify-center items-center z-50">
          <div className="relative bg-gray-800 p-6 rounded-lg max-w-sm w-full">
            <FaTimes
              className="absolute top-4 right-4 text-gray-400 hover:text-white cursor-pointer"
              onClick={fecharModal}
            />
            <h3 className="text-xl font-bold mb-2 text-white">Nova Senha</h3>

            <div className="relative mb-4">
              <FaLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type={showNewPassword ? "text" : "password"}
                placeholder="Nova senha"
                value={novaSenha}
                onChange={(e) => setNovaSenha(e.target.value)}
                className="w-full pl-10 pr-10 py-2 bg-gray-700 border border-gray-600 rounded-md text-white"
              />
              <span
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 cursor-pointer"
                onClick={() => setShowNewPassword(!showNewPassword)}
              >
                {showNewPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <div className="relative mb-4">
              <FaLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type={showConfirmPassword ? "text" : "password"}
                placeholder="Confirmar senha"
                value={confirmarSenha}
                onChange={(e) => setConfirmarSenha(e.target.value)}
                className="w-full pl-10 pr-10 py-2 bg-gray-700 border border-gray-600 rounded-md text-white"
              />
              <span
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 cursor-pointer"
                onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              >
                {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <button
              onClick={handleRedefinirSenha}
              className="w-full py-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 transition-all"
            >
              Alterar Senha
            </button>
          </div>
          
        </div>
      )}
    </div>
    </>
  );
};

export default Login;
